import { call, put } from 'redux-saga/effects';
import CreateWithdrawalActions from '../redux/CreateWithdrawalRedux';
import { api } from './api';


export function* createwithdrawalssagas(action: any): Generator<any, void, any> {
  const { salesforce_contact_id } = action;
  console.log('CreateWithdrawalsSaga: Starting withdrawal creation with:', salesforce_contact_id);
  
  const response = yield call(api.createWithdrawals, salesforce_contact_id);
  console.log('CreateWithdrawalsSaga: API response:', response);

  // success?
  if (response.ok) {
    console.log('CreateWithdrawalsSaga: Success, dispatching createWithdrawalsSuccess with:', response.data);
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(CreateWithdrawalActions.createWithdrawalsSuccess(response.data));
  } else {
    console.log('CreateWithdrawalsSaga: Failure, dispatching createWithdrawalsFailure');
    yield put(CreateWithdrawalActions.createWithdrawalsFailure());
  }
}